/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Unknown_EventInputs */

const th_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบอีเวนต์นี้`)
};

const en_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That event does not exist.`)
};

const ja_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この大会は存在しません。`)
};

const zh_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该赛事不存在。`)
};

const es_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese evento no existe.`)
};

const pt_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse evento não existe.`)
};

const id_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara itu tidak ada.`)
};

const fr_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet événement n’existe pas.`)
};

const tl_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala ang event na iyon.`)
};

const vi_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có sự kiện đó.`)
};

const ko_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그런 이벤트는 없습니다.`)
};

const de_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Event gibt es nicht.`)
};

const ru_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такого события нет.`)
};

const tr_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böyle bir etkinlik yok.`)
};

const it_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quell'evento non esiste.`)
};

const pl_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takie wydarzenie nie istnieje.`)
};

const uk_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такої події немає.`)
};

const hi_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह आयोजन मौजूद नहीं है।`)
};

const ar_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تلك الفعالية غير موجودة.`)
};

const ms_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara itu tidak wujud.`)
};

const bn_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই আয়োজন নেই।`)
};

const zh_tw2_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該賽事不存在。`)
};

const zh_hk2_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該賽事不存在。`)
};

const ur_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ ایونٹ موجود نہیں۔`)
};

const fa_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چنین رویدادی وجود ندارد.`)
};

const sw_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukio hilo halipo.`)
};

const nl_err_unknown_event = /** @type {(inputs: Err_Unknown_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat evenement bestaat niet.`)
};

/**
* | output |
* | --- |
* | "That event does not exist." |
*
* @param {Err_Unknown_EventInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_unknown_event = /** @type {((inputs?: Err_Unknown_EventInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Unknown_EventInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_unknown_event(inputs)
	if (locale === "ja") return ja_err_unknown_event(inputs)
	if (locale === "zh") return zh_err_unknown_event(inputs)
	if (locale === "es") return es_err_unknown_event(inputs)
	if (locale === "pt") return pt_err_unknown_event(inputs)
	if (locale === "id") return id_err_unknown_event(inputs)
	if (locale === "fr") return fr_err_unknown_event(inputs)
	if (locale === "tl") return tl_err_unknown_event(inputs)
	if (locale === "vi") return vi_err_unknown_event(inputs)
	if (locale === "ko") return ko_err_unknown_event(inputs)
	if (locale === "de") return de_err_unknown_event(inputs)
	if (locale === "ru") return ru_err_unknown_event(inputs)
	if (locale === "tr") return tr_err_unknown_event(inputs)
	if (locale === "it") return it_err_unknown_event(inputs)
	if (locale === "pl") return pl_err_unknown_event(inputs)
	if (locale === "uk") return uk_err_unknown_event(inputs)
	if (locale === "hi") return hi_err_unknown_event(inputs)
	if (locale === "ar") return ar_err_unknown_event(inputs)
	if (locale === "ms") return ms_err_unknown_event(inputs)
	if (locale === "bn") return bn_err_unknown_event(inputs)
	if (locale === "zh-TW") return zh_tw2_err_unknown_event(inputs)
	if (locale === "zh-HK") return zh_hk2_err_unknown_event(inputs)
	if (locale === "ur") return ur_err_unknown_event(inputs)
	if (locale === "fa") return fa_err_unknown_event(inputs)
	if (locale === "sw") return sw_err_unknown_event(inputs)
	if (locale === "nl") return nl_err_unknown_event(inputs)
	return en_err_unknown_event(inputs)
});